module.exports = __webpack_public_path__ + "img/tax.c2bd137d.png";